var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",staticClass:"button",class:[
    _vm.themeClass,
    _vm.sizeClass,
    _vm.bezelClass,
    _vm.iconClass,
    _vm.loadingClass,
    _vm.roundClass
  ],style:(_vm.style),attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('svg-icon',{staticClass:"iconBody iconBody--loading",attrs:{"name":"Spin"}}):[(_vm.iconName)?_c('svg-icon',{staticClass:"iconBody",attrs:{"name":_vm.iconName}}):_vm._e(),_c('span',{staticClass:"textBody"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }